<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.pdProcessDictStatus === 'D'
              ? 'danger'
              : row.pdProcessDictStatus === 'S'
              ? 'warning'
              : row.pdProcessDictStatus === 'Y'
              ? 'success'
              : ''
          "
        >
          {{ row.v_pdProcessDictStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ ...opt, row }"
                :divided="opt.divided"
                :disabled="
                  opt.status && opt.status.length
                    ? !opt.status.includes(row.pdProcessDictStatus)
                    : false
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ menuType, row }) {
      if (!menuType) return

      const { pdProcessDictCode, pdProcessDictNo } = row

      switch (menuType) {
        case 'detail':
        case 'reviewEdit':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { pdProcessDictCode },
            query: { pdProcessDictNo },
          })
          break
        case 'delete':
          this.del(row)
          break
        case 'copy':
          this.copy(row)
          break
        case 'review':
          this.review(row)
          break
        case 'deactivate':
          this.deactivate(row)
          break
        case 'enable':
          this.enable(row)
          break
      }
    },
    del({ pdProcessDictCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .processDictionaryDelApi({ pdProcessDictCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    copy({ pdProcessDictCode }) {
      this.$confirm(
        '是否复制该条记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .processDictionaryCopyApi({ pdProcessDictCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status, body } = res
        if (status !== 200) {
          this.$message.error('复制失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '复制成功',
          type: 'success',
        })
        this.$emit('reload')

        if (!body) return
        this.$emit('openEditPage', {
          pageType: 'edit',
          params: { pdProcessDictCode: body.pdProcessDictCode },
          query: { pdProcessDictNo: body.pdProcessDictNo },
        })
      })
    },
    review({ pdProcessDictCode }) {
      this.$confirm(
        '是否审核确定该条记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .processDictionaryReviewApi({ pdProcessDictCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(
            this.$l('INDEX.tips_audit_failure') || '审核失败！'
          )
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_audit_success') || '审核成功',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    deactivate({ pdProcessDictCode }) {
      this.$confirm(
        '是否停用该条记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .processDictionaryDeactivateApi({ pdProcessDictCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error('停用失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '停用成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    enable({ pdProcessDictCode }) {
      this.$confirm(
        '是否启用该条记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .processDictionaryEnableApi({ pdProcessDictCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error('启用失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '启用成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
  },
}
</script>
